import { Component, EventEmitter, inject, Input, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { TranslateModule } from '@ngx-translate/core'
import { Call, CallsService } from '../../calls.service'

@Component({
  selector: 'app-agenda-missing-warning',
  standalone: true,
  imports: [MatButton, TranslateModule],
  templateUrl: './agenda-missing-warning.component.html',
  styleUrl: './agenda-missing-warning.component.scss',
})
export class AgendaMissingWarningComponent {
  @Input({ required: true })
  call!: Call

  @Output()
  openAgendaUpload = new EventEmitter<void>()

  private callsService = inject(CallsService)
  approveMissingAgendaMutation = this.callsService.approveMissingAgendaMutation()

  async approveMissingAgenda() {
    await this.approveMissingAgendaMutation.mutateAsync(this.call.id)
  }
}
